import React from "react";
import Loader from "../../components/loader";
import { t } from "../../../helpers/translator";
import InputKeyboard from "../../components/InputKeyboard";
import SportResults from "./sport";
import Config from "../../../config/main";
import VirtualsResult from "./virtuals";
import DatePicker from "@common/components/datePicker";

export default function resultTemplate() {
	// eslint-disable-next-line camelcase
	let {
		data,
		selectedSport,
		startDay,
		sportComps,
		isLoading,
		searchInput,
		inputText,
		filteredData,
		isFiltred,
		errMessage,
		dropDown,
	} = this.state;
	if (data && selectedSport) {
		return (
			<div className="results-container " onClick={this.closeDropDown}>
				<div className="results-container-header">
					<div className="title-item">{t(`Result`)}</div>
					<div className="info-item">
						<div className="inside-info">
							<div className="date-from">
								<DatePicker
									onlyPast
									selected={startDay}
									onChange={this.handleChangeDateFrom}
								/>
							</div>
							<div className="sport-select">
								<div
									onClick={this.toggleDropDown}
									className={`drop-down-select ${
										dropDown && "active"
									}`}
								>
									<p>{selectedSport.Name}</p>
								</div>
								<ul>
									{dropDown &&
										data.map(item =>
											item.Id === 184 ||
											item.Id === 31 ||
											item.Id === 181
												? null
												: item.Id !==
														selectedSport.Id && (
														<li
															onClick={() =>
																this.handleChangeSelect(
																	item
																)
															}
														>
															<p>
																{
																	item.Name
																}
															</p>
														</li>
												  )
										)}
								</ul>
								<div className="select-icon"></div>
							</div>
						</div>
						<div className="search-button">
							<div className="search" onClick={this.searchToggle}>
								<span>{t(`SEARCH`)}</span>
							</div>
							{searchInput && (
								<InputKeyboard
									class={"search-place"}
									onChange={this.handleChange}
									value={inputText}
									placeholder={t("Type to search...")}
								/>
							)}
						</div>
					</div>
				</div>
				{!isFiltred && errMessage ? (
					<div className="no-game">{t(`No Games To Show`)}</div>
				) : sportComps && !isLoading ? (
					!Config.main.resultPageVirtualsId.includes(Number(selectedSport.Id)) ? (
						<SportResults
							sportComps={sportComps.sort((a, b) => b.date - a.date)}
							filteredData={filteredData.sort((a, b) => a.date - b.date)}
							isFiltred={isFiltred}
						/>
					) : (
						Config.main.resultPageVirtualsId.includes(Number(selectedSport.Id)) && (
							<VirtualsResult
								sportComps={sportComps.sort((a, b) => b.date - a.date)}
								filteredData={filteredData.sort(
									(a, b) => a.date - b.date
								)}
								isFiltred={isFiltred}
							/>
						)
					)
				) : (
					<Loader component="result 1" />
				)}
				{sportComps && sportComps.length < 1 && (
					<div className="no-game">{t(`No Games To Show`)}</div>
				)}
			</div>
		);
	}
	if (this.state.loading) {
		return <Loader component="result 2" />;
	} else 
		return <div>{t('No data to show')}</div>
}
